//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "QuizQuestionResultGridView",
  created() {},
  props: ["result"],
  data() {
    return {
      answerCharacters: this.result.get("baseQuestion").get("answer").split(""),
    };
  },
  computed: {
    question: function () {
      return this.result.get("baseQuestion");
    },
  },
  methods: {},
};



// WEBPACK FOOTER //
// ./src/components/quiz/quiz_question_result/QuizQuestionResultGridView.vue